import { Component, OnInit } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
declare var $: any;
import {
  faInfo,
  faFileExport,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faEdit,
  faLightbulb,
  faTrash,
  faTimes,
  faClipboardList,
  faCircle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
import { MainComponent } from '../main/main.component';
@Component({
  selector: 'app-test-manager',
  templateUrl: './test-manager.component.html',
  styleUrls: ['./test-manager.component.scss'],
})
export class TestManagerComponent implements OnInit {
  faClipboardList = faClipboardList;
  faInfoCircle = faInfoCircle;
  faFileExport = faFileExport;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faPlus = faPlus;
  faEdit = faEdit;
  faTrash = faTrash;
  faLightbulb = faLightbulb;
  faTimes = faTimes;
  faCircle = faCircle;
  clickEventsubscriptionSocket: Subscription;
  smartChecklist: boolean = true;
  eutTypeSelected: any = [];
  eutTypeSelectedSuite: any = [];
  syncModelDataObject: any;

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private reloadToolService: ReloadToolService,
    public Config: Config,
    public mainComponent: MainComponent,
    private AppService: AppService
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
  }

  ngOnInit(): void {
    $(() => {
      $('[data-toggle="popover"]').popover();
      $('[data-toggle="tooltip"]').tooltip();
    });
    setTimeout(() => {
      this.getVideoURL('Tm');
    }, 2000);
    this.config = this.Config;
    this.modelData = this._sharedService.loadedProjectData.model;
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    this.reloadToolService.triggerSmartChecklist('');
  }
  // attributes = this.config.listOfAttributes;
  this: any;
  modelData: any;
  config: any;
  model: any;
  listOfAttributes: any = this.Config.listOfAttributesUpdated;
  // listOfAttributes1: any = [
  //   {
  //     name: 'Migration',
  //     symbol: 'Mi',
  //     level: 'L8',
  //   },
  //   {
  //     name: 'Installation',
  //     symbol: 'In',
  //     level: 'L8',
  //   },
  //   {
  //     name: 'Configuration',
  //     symbol: 'Co',
  //     level: 'L8',
  //   },
  //   {
  //     name: 'System Integration',
  //     symbol: 'Si',
  //     level: 'L8',
  //   },
  //   {
  //     name: 'Performance',
  //     symbol: 'Pf',
  //     level: 'L7',
  //   },
  //   {
  //     name: 'Load',
  //     symbol: 'Lo',
  //     level: 'L7',
  //   },
  //   {
  //     name: 'Reliability',
  //     symbol: 'Re',
  //     level: 'L7',
  //   },
  //   {
  //     name: 'Security',
  //     symbol: 'Se',
  //     level: 'L7',
  //   },
  //   {
  //     name: 'Usability',
  //     symbol: 'Us',
  //     level: 'L7',
  //   },
  //   {
  //     name: 'Browser Compatibility',
  //     symbol: 'Bc',
  //     level: 'L6',
  //   },
  //   {
  //     name: 'Environment Compatibility',
  //     symbol: 'Ec',
  //     level: 'L6',
  //   },
  //   {
  //     name: 'Requirement Behaviour',
  //     symbol: 'Rb',
  //     level: 'L5',
  //   },
  //   {
  //     name: 'Flow Behaviour',
  //     symbol: 'Fb',
  //     level: 'L5',
  //   },
  //   {
  //     name: 'Feature Behaviour',
  //     symbol: 'Fe',
  //     level: 'L4',
  //   },
  //   {
  //     name: 'Access Control',
  //     symbol: 'Ac',
  //     level: 'L4',
  //   },
  //   {
  //     name: 'UI Interface',
  //     symbol: 'Ui',
  //     level: 'L123',
  //   },
  //   {
  //     name: 'Structural Behaviour',
  //     symbol: 'St',
  //     level: 'L123',
  //   },
  //   // {
  //   //   name: 'Data Validation',
  //   //   symbol: 'Dt',
  //   //   level: 'L123',
  //   // },
  // ];
  // this.model = model;

  // this.scopeMap = scopeMap;
  // this.AppService = AppService;
  // this.tasks = tasks;
  // this.planner = planner;
  // this.taskPlanner1 = taskPlanner1;
  toastMsgPopup = '';
  scenarioFilter = 'Entity';
  selectedEntity = 'TF';
  activeTab = 'scenarios';
  index = 0;
  detailsAttributeCount = 0;
  eutTypes = ['TF', 'UR', 'BF', 'XX'];
  selectedEUT = 'TF';
  selectedSuite: any = { suiteId: '', suiteName: '', scenarios: [] };
  suiteObj: any = {};
  showText = false;
  oldSuiteName: any = '';
  new = true;
  updateSuitename = false;
  topSelectedList: any = [];
  bottomSelectedList: any = [];
  allScenarios: any = '';
  filterTypeCount: any = { type: 'count' };
  filterTypeList: any = { type: 'list' };
  //filters for the scenario table
  eutSelected: any = [];
  moduleSelected: any = [];
  attributeSelected: any = [];
  crSelected: any = [];
  prioritySelected: any = [];
  // allScenarios = modelData.scenarios;
  indexSuite = 0;
  selectedEUTSuite = 'TF';
  suiteName = '';
  eutSelectedSuite: any = [];
  moduleSelectedSuite: any = [];
  attributeSelectedSuite: any = [];
  crSelectedSuite: any = [];
  levelSelectedSuite: any = [];
  AttributestatusTF = 0;
  AttributestatusUR = 0;
  AttributestatusBF = 0;
  AttributestatusXX = 0;
  matchedScenarioCount = 0;
  matchedSuiteScenarioCount = 0;
  attributes = '';
  entityName = '';

  //intiliaze all counts to zero
  readyEUTCount = 0;
  notReadyEUTCount = 0;
  scenarioTotalTT = 0;
  scenarioTT = 0;
  scenarioTotalTF = 0;
  scenarioTF = 0;
  scenarioTotalUR = 0;
  scenarioUR = 0;
  scenarioTotalBF = 0;
  scenarioBF = 0;
  scenarioTotalXX = 0;
  scenarioXX = 0;
  scenarioTFPositive = 0;
  scenarioTFNegative = 0;
  scenarioBFPositive = 0;
  scenarioBFNegative = 0;
  scenarioURPositive = 0;
  scenarioURNegative = 0;
  scenarioXXPositive = 0;
  scenarioXXNegative = 0;
  scenarioTTPositive = 0;
  scenarioTTNegative = 0;
  readyEUTStatus = 0;
  scenarioTFStatus = 0;
  scenarioURStatus = 0;
  scenarioBFStatus = 0;
  scenarioXXStatus = 0;
  scenarioTTStatus = 0;
  euts: any = 0;
  scenarios: any = 0;

  scenarioAttriCount = 0;
  scopeAttriArrayTF = [];
  scopeAttriArrayBF = [];
  scopeAttriArrayUR = [];

  totalTFCount = 0;
  totalURCount = 0;
  totalBFCount = 0;
  totalXXCount = 0;
  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }
  openChatGPTassist() {
    this.mainComponent.openChatGPT();
    window.localStorage.setItem("assistantTool", "RECON");
    setTimeout(() => {
      // if (this.choosenEUT) {
      //   this.loadEntityDetails(this.choosenEUT);
      // }
    }, 500);
  }
  onReloadInit(listOfAttributes: any, scopeMap: any) {
    // console.log('reload init for testmanger');
    this.attributes = listOfAttributes;
    // this.scopeMap = scopeMap;
    // if(this.suiteObj){
    //   this.selectedSuitefound = this.modelData.suites.find(suite => suite.suiteName == this.suiteObj.suiteName);
    //   // console.log('selectedSuitefound', this.selectedSuitefound);
    //   if (this.selectedSuitefound) {
    //     this.chooseSuite(this.new, this.showText, this.suiteObj);
    //   } else{
    //       this.selectedSuite = '';
    //       this.suiteName = '';
    //       this.suiteObj = '';
    //     }
    // }
    this.generateEUTStatus();
    this.attributeCount();
    this.generateAttriStatus();
    // this.changeEntity('TF');
    this.changeEntitySuite('TF');
  }
  //changing the entity type by toggling the span button
  //reset the entity name and details populated in the form
  changeEntity(test: any) {
    for (let k = 0; k < this.eutTypes.length; k++) {
      if (this.eutTypes[k] == test) {
        this.index = k;
        this.selectedEUT = test;
        this.eutSelected = [];
        this.countScenarioEUTType(this.modelData.scenarios);
        if (this.topSelectedList.length != 0) {
          this.addAllFromScenarios(false);
          // document.getElementById("selectAllAdd").checked = false;
        }
        this.indexSuite = k;
        this.selectedEUTSuite = test;
        this.eutSelectedSuite = [];
        this.countSuiteScenarioEUTType(this.selectedSuite);
        if (this.bottomSelectedList.length != 0) {
          this.addAllFromSuite(false);
          // document.getElementById("selectAllRemove").checked = false;
        }
      }
    }
    this.index = (this.index + 1) % this.eutTypes.length;
    this.entityName = '';
  }

  changeEntitySuite(test: any) {
    for (let k = 0; k < this.eutTypes.length; k++) {
      if (this.eutTypes[k] == test) {
        this.indexSuite = k;
        this.selectedEUTSuite = test;
        this.eutSelectedSuite = [];
        this.countSuiteScenarioEUTType(this.selectedSuite);
        if (this.bottomSelectedList.length != 0) {
          this.addAllFromSuite(false);
          // document.getElementById("selectAllRemove").checked = false;
        }
        this.index = k;
        this.selectedEUT = test;
        this.eutSelected = [];
        this.countScenarioEUTType(this.modelData.scenarios);
        if (this.topSelectedList.length != 0) {
          this.addAllFromScenarios(false);
          // document.getElementById("selectAllAdd").checked = false;
        }
      }
    }
    this.entityName = '';
  }

  // filterPersona() {
  // this.persona.find(persona);
  // }
  changeRadio(type: any) {
    this.scenarioFilter = type;
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
    if (this.smartChecklist == false) {
      $(".autoCursor").addClass('checklistIcon');
      this.smartChecklist = true;
    } else {
      $(".autoCursor").removeClass('checklistIcon');
      this.smartChecklist = false;
    }
  }
  generateEUTStatus() {
    this.readyEUTCount = 0;
    this.notReadyEUTCount = 0;
    this.scenarioTotalTT = 0;
    this.scenarioTT = 0;
    this.scenarioTotalTF = 0;
    this.scenarioTF = 0;
    this.scenarioTotalUR = 0;
    this.scenarioUR = 0;
    this.scenarioTotalBF = 0;
    this.scenarioBF = 0;
    this.scenarioTotalXX = 0;
    this.scenarioXX = 0;
    this.scenarioTFPositive = 0;
    this.scenarioTFNegative = 0;
    this.scenarioBFPositive = 0;
    this.scenarioBFNegative = 0;
    this.scenarioURPositive = 0;
    this.scenarioURNegative = 0;
    this.scenarioXXPositive = 0;
    this.scenarioXXNegative = 0;
    this.scenarioTTPositive = 0;
    this.scenarioTTNegative = 0;
    this.readyEUTStatus = 0;
    this.scenarioTFStatus = 0;
    this.scenarioURStatus = 0;
    this.scenarioBFStatus = 0;
    this.scenarioXXStatus = 0;
    this.scenarioTTStatus = 0;
    this.euts = this.modelData.listOfEUTs;
    this.scenarios = this.modelData.scenarios;
    // for (var i = 0; i < this.euts.length; i++) {
    // this.matchedEutinfo = this.scenarios.find(sec => sec.eID == this.euts[i].eID);
    // if (this.matchedEutinfo) {
    // this.readyEUTCount++
    for (var j = 0; j < this.scenarios.length; j++) {
      if (this.scenarios[j].eID != undefined) {
        if (this.scenarios[j].eType == 'TF') {
          this.scenarioTF++;
          if (this.scenarios[j].cr == '+') {
            this.scenarioTFPositive++;
          } else {
            this.scenarioTFNegative++;
          }
        } else if (this.scenarios[j].eType == 'BF') {
          this.scenarioBF++;
          if (this.scenarios[j].cr == '+') {
            this.scenarioBFPositive++;
          } else {
            this.scenarioBFNegative++;
          }
        } else if (this.scenarios[j].eType == 'UR') {
          this.scenarioUR++;
          if (this.scenarios[j].cr == '+') {
            this.scenarioURPositive++;
          } else {
            this.scenarioURNegative++;
          }
        } else if (this.scenarios[j].eType == 'XX') {
          this.scenarioXX++;
          if (this.scenarios[j].cr == '+') {
            this.scenarioXXPositive++;
          } else {
            this.scenarioXXNegative++;
          }
        }
      }
      // } else {
      //   this.notReadyEUTCount++
      // }
      // if (this.euts[i].eType == 'TF') {
      //   this.scenarioTotalTF++
      // } else if (this.euts[i].eType == 'BF') {
      //   this.scenarioTotalBF++
      // } else if (this.euts[i].eType == 'UR') {
      //   this.scenarioTotalUR++
      // }
    }
    // }
    // if (this.readyEUTCount != 0) {
    //   this.readyEUTStatus = Math.round((this.readyEUTCount / this.euts.length) * 100);
    // }
    if (this.scenarioTF != 0) {
      this.scenarioTFStatus = Math.round(
        (this.scenarioTF / this.scenarios.length) * 100
      );
    }
    if (this.scenarioUR != 0) {
      this.scenarioURStatus = Math.round(
        (this.scenarioUR / this.scenarios.length) * 100
      );
    }
    if (this.scenarioBF != 0) {
      this.scenarioBFStatus = Math.round(
        (this.scenarioBF / this.scenarios.length) * 100
      );
    }
    if (this.scenarioXX != 0) {
      this.scenarioXXStatus = Math.round(
        (this.scenarioXX / this.scenarios.length) * 100
      );
    }
    // for (var j = 0; j < this.scenarios.length; j++) {
    //   if (this.scenarios[j].EorT == 'T') {
    //     this.scenarioTotalTT++
    //     if (this.scenarios[j].cr == '+') {
    //       this.scenarioTTPositive++
    //     } else {
    //       this.scenarioTTNegative++
    //     }
    //   }
    // }
    // if (this.scenarioTotalTT != 0) {
    //   this.scenarioTTStatus = Math.round((this.scenarioTotalTT / this.scenarioTotalTT) * 100);
    // }
  }

  generateAttriStatus() {
    this.scenarioAttriCount = 0;
    this.scopeAttriArrayTF = [];
    this.scopeAttriArrayBF = [];
    this.scopeAttriArrayUR = [];
    // console.log("appConst.listOfAttributes", appConst.listOfAttributes);
    // for (var i = 0; i < appConst.listOfAttributes.length; i++) {
    //   for (var j = 0; j < this.scopeMap.length; j++) {
    //     if (this.scopeMap[j].aType == appConst.listOfAttributes[i].symbol) {
    //       if (this.scopeMap[j].eType == 'TF') {
    //         if (this.scopeAttriArrayTF.indexOf(appConst.listOfAttributes[i].symbol) > -1) {

    //         } else {
    //           this.scopeAttriArrayTF.push(appConst.listOfAttributes[i].symbol);
    //         }
    //       } else if (this.scopeMap[j].eType == 'BF') {
    //         if (this.scopeAttriArrayBF.indexOf(appConst.listOfAttributes[i].symbol) > -1) {

    //         } else {
    //           this.scopeAttriArrayBF.push(appConst.listOfAttributes[i].symbol);
    //         }
    //       } else if (this.scopeMap[j].eType == 'UR') {
    //         if (this.scopeAttriArrayUR.indexOf(appConst.listOfAttributes[i].symbol) > -1) {

    //         } else {
    //           this.scopeAttriArrayUR.push(appConst.listOfAttributes[i].symbol);
    //         }
    //       }
    //     }
    //   }
    // }
    // console.log("A", this.scopeAttriArrayTF);
    // console.log("A", this.scopeAttriArrayBF);
    // console.log("A", this.scopeAttriArrayUR);
    // console.log("count", appConst.listOfAttributes.length);
    //appConst.listOfAttributes.length
    this.totalTFCount = 0;
    this.totalURCount = 0;
    this.totalBFCount = 0;
    this.totalXXCount = 0;
    for (var i = 0; i < this.modelData.listOfEUTs.length; i++) {
      if (this.modelData.listOfEUTs[i].eType == 'TF') {
        this.totalTFCount++;
      } else if (this.modelData.listOfEUTs[i].eType == 'UR') {
        this.totalURCount++;
      } else if (this.modelData.listOfEUTs[i].eType == 'BF') {
        this.totalBFCount++;
      } else if (this.modelData.listOfEUTs[i].eType == 'XX') {
        this.totalXXCount++;
      }
    }
    this.AttributestatusTF = Math.round(
      (this.totalTFCount / this.modelData.listOfEUTs.length) * 100
    );
    this.AttributestatusBF = Math.round(
      (this.totalBFCount / this.modelData.listOfEUTs.length) * 100
    );
    this.AttributestatusUR = Math.round(
      (this.totalURCount / this.modelData.listOfEUTs.length) * 100
    );
    this.AttributestatusXX = Math.round(
      (this.totalXXCount / this.modelData.listOfEUTs.length) * 100
    );
  }
  //function to change the selected entity from dropdown
  choseEntity(entity: any) {
    this.selectedEntity = entity;
  }

  attributeCount() {
    this.detailsAttributeCount = 0;
    for (var i = 0; i < this.config.listOfAttributesUpdated.length; i++) {
      if (this.config.listOfAttributesUpdated[i].aDetail != '') {
        this.detailsAttributeCount++;
      }
    }
  }
  //given an entity-> function returns the number and percentage of scenarios for this entity
  getCountForEntity(entity: any) {
    var scenario = this.getTMCountForEntity(entity.eID);
    return scenario;
  }

  //given an test Type-> function returns the number and percentage of scenarios for this testType
  getCountForTestType(testType: any) {
    var scenario = this.getTMCountForTestType(testType.symbol);
    return scenario;
  }

  //given an persona-> function returns the number and percentage of scenarios for this persona
  getCountForModule(module: any) {
    var scenario = this.getTMCountForModule(module);
    return scenario;
  }

  getCountForLevel(level: any) {
    var scenario = this.getTMCountForLevel(level);
    return scenario;
  }

  getCountForSuites(suite: any) {
    var scenario = {
      count: 0,
      percent: 0,
      positive: 0,
      negative: 0,
    };

    scenario.count = suite.scenarios.length;
    for (var i = 0; i < suite.scenarios.length; i++) {
      if (suite.scenarios[i].cr == '+') {
        scenario.positive++;
      } else {
        scenario.negative++;
      }
    }
    var percent =
      (suite.scenarios.length / this.modelData.scenarios.length) * 100;
    if (!percent) {
      scenario.percent = 0;
    } else {
      scenario.percent = Math.round(percent);
    }
    // scenario.percent =
    //   (suite.scenarios.length / this.modelData.scenarios.length) * 100;
    return scenario;
  }

  getTMCountForEntity(eID: any) {
    var scenario = {
      count: 0,
      percent: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios = this.modelData.scenarios.filter(
      (scenario: any) => scenario.eID == eID
    );
    for (var i = 0; i < scenarios.length; i++) {
      if (scenarios[i].cr == '+') {
        scenario.positive++;
      } else {
        scenario.negative++;
      }
    }
    scenario.count = scenarios.length;
    var percent = (scenarios.length / this.scenarios.length) * 100;
    if (!percent) {
      scenario.percent = 0;
    } else {
      scenario.percent = Math.round(percent);
    }
    return scenario;
  }

  getTMCountForTestType(tID: any) {
    var scenario = {
      count: 0,
      percent: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios = this.modelData.scenarios.filter(
      (scenario: any) => scenario.tID == tID
    );
    for (var i = 0; i < scenarios.length; i++) {
      if (scenarios[i].cr == '+') {
        scenario.positive++;
      } else {
        scenario.negative++;
      }
    }
    scenario.count = scenarios.length;
    var percent = (scenarios.length / this.scenarios.length) * 100;
    if (!percent) {
      scenario.percent = 0;
    } else {
      scenario.percent = Math.round(percent);
    }
    return scenario;
  }

  getTMCountForModule(module: any) {
    var scenario = {
      count: 0,
      percent: 0,
      positive: 0,
      negative: 0,
    };
    var scenarios: any = [];
    var moduleEUTs: any = [];
    for (var j = 0; j < this.modelData.listOfEUTs.length; j++) {
      if (this.modelData.listOfEUTs[j].mID == module) {
        moduleEUTs.push(this.modelData.listOfEUTs[j]);
        for (var k = 0; k < this.modelData.scenarios.length; k++) {
          if (this.modelData.scenarios[k].eID == this.modelData.listOfEUTs[j].eID) {
            scenarios.push(this.modelData.scenarios[k]);
          }
        }
      }
    }

    // var scenarios = this.modelData.scenarios.filter(function (scenario: any) {
    //   var index = scenario.persona.findIndex(
    //     (persona: any) => persona == person
    //   );
    //   if (index > -1) {
    //     return scenario;
    //   }
    // });
    for (var i = 0; i < scenarios.length; i++) {
      if (scenarios[i].cr == '+') {
        scenario.positive++;
      } else {
        scenario.negative++;
      }
    }
    scenario.count = scenarios.length;
    var percent = (scenarios.length / this.modelData.scenarios.length) * 100;
    if (!percent) {
      scenario.percent = 0;
    } else {
      scenario.percent = Math.round(percent);
    }
    return scenario;
  }
  getVideoURL(urlName: any) {
    var videoURL = this.AppService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }
  getTMCountForLevel(level: any) {
    // var model = this;
    var scenario = {
      count: 0,
      percent: 0,
      positive: 0,
      negative: 0,
    };

    // var scenarios = this.modelData.scenarios.filter(function (scenario: any) {
    //   var aTest = this.config.listOfAttributes.find(
    //     (testType: any) => testType.symbol == scenario.tID
    //   );
    //   if (aTest && aTest.level == attribute.level) {
    //     return scenario;
    //   }
    // });
    var scenarios: any = [];
    for (var j = 0; j < this.modelData.scenarios.length; j++) {
      if (this.modelData.scenarios[j].attribute.level == level) {
        scenarios.push(this.modelData.scenarios[j]);
      }
      // for (var k = 0; k < this.config.listOfAttributes.length; k++) {
      //   if (
      //     this.config.listOfAttributes[k].symbol ==
      //     this.modelData.scenarios[j].tID
      //   ) {
      //     if (this.config.listOfAttributes[k].level == level) {
      //       scenarios.push(this.modelData.scenarios[j]);
      //     }
      //   }
      // }
    }
    for (var i = 0; i < scenarios.length; i++) {
      if (scenarios[i].cr == '+') {
        scenario.positive++;
      } else {
        scenario.negative++;
      }
    }
    scenario.count = scenarios.length;
    var percent = (scenarios.length / this.modelData.scenarios.length) * 100;
    if (!percent) {
      scenario.percent = 0;
    } else {
      scenario.percent = Math.round(percent);
    }
    return scenario;
  }

  getTMScenario(scenrioID: any) {
    var scenario = this.modelData.scenarios.find(
      (scenario: any) => scenario.scenID == scenrioID
    );
    return scenario;
  }

  getScenarioCountForEntity(eID: any, attribute: any) {
    var count = {
      total: 0,
      positive: 0,
      negative: 0,
    };
    var positive = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '+' && scenario.tID == attribute
    );
    var negative = this.scenarios.filter(
      (scenario: any) =>
        scenario.eID == eID && scenario.cr == '-' && scenario.tID == attribute
    );
    count.total = positive.length + negative.length;
    count.positive = positive.length;
    count.negative = negative.length;
    return count;
  }
  chooseSuite(newButton: any, textBox: any, suite: any) {
    // console.log("textBox", textBox);
    this.new = newButton;
    this.showText = textBox;
    this.selectedSuite = suite;
    // console.log('selectedSuite', this.selectedSuite);
    this.suiteName = suite.suiteName;
    this.suiteObj = suite;
    this.countSuiteScenarioEUTType(this.selectedSuite);
    this.countScenarioEUTType(this.allScenarios);
    if (this.topSelectedList.length != 0) {
      this.addAllFromScenarios(false);
      // document.getElementById("selectAllAdd").checked = false;
    }
    if (this.bottomSelectedList.length != 0) {
      this.addAllFromSuite(false);
      // document.getElementById("selectAllRemove").checked = false;
    }
  }

  addSuite(newname: any) {
    // console.log("this.suiteName", this.suiteName);
    var newSuite = this.suiteName.trim();
    if (newSuite == undefined || newSuite == "") {
      this.triggerToastPopup("Suite can't be empty");
      this.suiteName = "";
      return;
    }
    for (let j = 0; j < this.modelData.suites.length; j++) {
      if (
        this.modelData.suites[j].suiteName.toUpperCase() ==
        this.suiteName.toUpperCase()
      ) {
        this.triggerToastPopup(this.AppService.getResourceText('V026'));
        return;
      }
    }
    var suiteObj = {
      suiteName: this.suiteName,
      scenarios: [],
      suiteId: this.uuidv4(),
    }
    this.modelData.suites.push(suiteObj);
    this.syncModelDataObject = {
      "type": "SUITE",
      "operation": "CREATE",
      "data": suiteObj
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    // console.log("newnameSuites", this.modelData.suites);
    this.new = false;
    this.showText = false;
    var suite = this.modelData.suites.find(
      (suite: any) => suite.suiteName == this.suiteName
    );
    // console.log("suite", suite);
    this.selectedSuite = suite;
    this.suiteName = suite.suiteName;
  }

  editSuite(oldName: any) {
    this.showText = true;
    this.updateSuitename = true;
    this.oldSuiteName = oldName;
  }

  saveSuite(newname: any, oldname: any, updateSuite: any) {
    if (this.new) {
      this.addSuite(this.suiteName);
    } else {
      for (let i = 0; i < this.modelData.suites.length; i++) {
        if (
          this.modelData.suites[i].suiteName.toUpperCase() ==
          this.suiteName.toUpperCase()
        ) {
          this.triggerToastPopup(this.AppService.getResourceText('V026'));
          return;
        }
      }
      var suiteUpdate = this.modelData.suites.find(
        (suite: any) => suite.suiteId == this.selectedSuite.suiteId
      );
      suiteUpdate.suiteName = this.suiteName;
      this.syncModelDataObject = {
        "type": "SUITE",
        "operation": "UPDATE",
        "data": suiteUpdate
      }
      this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
      // this.updateTasksBasedOnSuiteId(suiteUpdate);
      this.new = false;
      this.showText = false;
    }
  }

  //Update tasks with rescept to when suite updated
  // updateTasksBasedOnSuiteId(suite: any) {
  // // console.log("check",checklist);
  // for (var i = 0; i < this.tasks.length; i++) {
  //   if (this.tasks[i].activity) {
  //     if (this.tasks[i].activity.type == 'RS') {
  //       // console.log("task",this.tasks[i]);
  //       if (this.tasks[i].suiteDetails.suiteId == suite.suiteId) {
  //         var updatedDesc = this.tasks[i].task_desc.replace(/'.*?'/, "\'" + suite.suiteName + "\'");
  //         this.tasks[i]['task_desc'] = updatedDesc;
  //         this.tasks[i].suiteDetails['suiteName'] = suite.suiteName;
  //       }
  //     }
  //   }
  // }
  // // this.planner.controller.loadMytasksList(this.tasks);
  // // this.taskPlanner1.controller.loadPlanNamesList(this.tasks);
  // // this.taskPlanner1.controller.selectedPlan(false, false, '');
  // }
  deleteSuite() {
    var index = this.modelData.suites.findIndex(
      (suite: any) => suite.suiteId == this.selectedSuite.suiteId
    );
    var suiteID = this.selectedSuite.suiteId;

    if (index) {
      this.modelData.suites.splice(index, 1);
    }
    if (index == 0) {
      this.modelData.suites.shift();
    }
    this.syncModelDataObject = {
      "type": "SUITE",
      "operation": "DELETE",
      "data": this.selectedSuite
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    setTimeout(() => {
      this.selectedSuite = { suiteId: '', suiteName: '', scenarios: [] };
    }, 1000);
    this.new = true;
    this.showText = false;
    this.topSelectedList = [];
    this.bottomSelectedList = [];
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  triggerToastPopup(message: any) {
    this.toastMsgPopup = message;
    $('#testmanagerMsgPopup').modal('toggle');
  }

  getEntity(eutID: any) {
    var entity = { eType: '', eName: '' };
    if (eutID) {
      var record = this.modelData.listOfEUTs.find(
        (eut: any) => eut.eID == eutID
      );
      if (record) {
        entity = {
          eType: record.eType,
          eName: record.eName,
        };
      }
    }
    return entity;
  }

  getScenario(sID: any) {
    var scenario = this.getTMScenario(sID.trim());
    return scenario;
  }

  getEntityForScenario(sID: any) {
    var scenario = this.getTMScenario(sID.trim());
    if (scenario) {
      if (scenario.EorT == 'E') {
        var entity = this.getEntity(scenario.eID);
        return entity;
      }
    } else {
      return scenario;
    }
  }

  getRunDetailsForScenario(sID: any) {
    var record = this.modelData.runInfo.find((aRun: any) => aRun.scenID == sID);
    if (record) {
      return record;
    }
  }

  toggleSelection(sID: any) {
    // if value is true -> remove from deselect list
    // if value is false -> add to deselect list
    if (this.selectedSuite.suiteName != '') {
      var isPresent = this.topSelectedList.findIndex(
        (scenID: any) => scenID == sID
      );
      // Is currently selected
      if (isPresent > -1) {
        this.topSelectedList.splice(isPresent, 1);
      }
      // Is newly selected
      else {
        this.topSelectedList.push(sID);
      }
    }
  }

  toggleSelectionInSuites(sID: any) {
    var isPresent = this.bottomSelectedList.findIndex(
      (scenID: any) => scenID == sID
    );
    // Is currently selected
    if (isPresent > -1) {
      this.bottomSelectedList.splice(isPresent, 1);
    }
    // Is newly selected
    else {
      this.bottomSelectedList.push(sID);
    }
  }

  addScenariosToSuite() {
    if (this.selectedSuite.scenarios.length > 0) {
      this.topSelectedList.forEach((id: any) => {
        for (var i = 0; i < this.selectedSuite.scenarios.length; i++) {
          if (this.selectedSuite.scenarios[i] != id) {
            this.selectedSuite.scenarios.push(id);
            return;
          }
        }
      });
    } else {
      this.selectedSuite.scenarios = this.topSelectedList;
    }
    this.syncModelDataObject = {
      "type": "SUITE",
      "operation": "PUSH",
      "data": this.topSelectedList,
      "suiteId": this.selectedSuite.suiteId
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    setTimeout(() => {
      this.topSelectedList = [];
    }, 1000);
    this.countScenarioEUTType(this.allScenarios);
    this.countSuiteScenarioEUTType(this.selectedSuite);
    // document.getElementById("selectAllAdd").checked = false;
  }

  removeScenariosToSuite() {

    this.bottomSelectedList.forEach((id: any) => {
      var isPresent = this.selectedSuite.scenarios.findIndex(
        (scenID: any) => scenID == id
      );
      if (isPresent > -1) {
        this.selectedSuite.scenarios.splice(isPresent, 1);
      }
    });
    this.syncModelDataObject = {
      "type": "SUITE",
      "operation": "SPLICE",
      "data": this.bottomSelectedList,
      "suiteId": this.selectedSuite.suiteId
    }
    this.mainComponent.updateActiveUsersModel(this.syncModelDataObject);
    setTimeout(() => {
      this.bottomSelectedList = [];
    }, 1000);
    this.countScenarioEUTType(this.allScenarios);
    this.countSuiteScenarioEUTType(this.selectedSuite);
    if (this.topSelectedList.length != 0) {
      this.addAllFromScenarios(false);
      // document.getElementById("selectAllAdd").checked = false;
    }

    // document.getElementById("selectAllRemove").checked = false;
  }

  isPresentInSuite(id: any) {
    if (this.selectedSuite.suiteName != '') {
      if (this.selectedSuite.scenarios != undefined) {
        var isPresent = this.selectedSuite.scenarios.findIndex(
          (scenID: any) => scenID == id
        );
      }
      if (isPresent > -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  addToEntityFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.eutSelected.push(id);
    } else {
      var isPresent = this.eutSelected.findIndex((eut: any) => eut == id);
      if (isPresent > -1) {
        this.eutSelected.splice(isPresent, 1);
      }
    }
    this.countScenarioEUTType(this.allScenarios);
    if (this.topSelectedList.length != 0) {
      this.addAllFromScenarios(false);
      // document.getElementById("selectAllAdd").checked = false;
    }
  }
  addToEntityTypeFilter(type: any, isChecked: any) {
    if (isChecked) {
      this.eutTypeSelected.push(type);
    } else {
      var isPresent = this.eutTypeSelected.findIndex((eut: any) => eut == type);
      if (isPresent > -1) {
        this.eutTypeSelected.splice(isPresent, 1);
      }
    }
    this.countScenarioEUTType(this.allScenarios);
    if (this.topSelectedList.length != 0) {
      this.addAllFromScenarios(false);
      // document.getElementById("selectAllAdd").checked = false;
    }
    // console.log("this.eutTypeSelected",this.eutTypeSelected);
  }
  isPresentInCollection(eutID: any) {
    var isPresent = this.eutSelected.findIndex((eut: any) => eut == eutID);
    if (isPresent > -1) {
      return true;
    } else return false;
  }

  addToEntityFilterSuite(id: any, isChecked: any) {
    if (isChecked) {
      this.eutSelectedSuite.push(id);
    } else {
      var isPresent = this.eutSelectedSuite.findIndex((eut: any) => eut == id);
      if (isPresent > -1) {
        this.eutSelectedSuite.splice(isPresent, 1);
      }
    }
    // this.countSuiteScenarioEUTType(this.selectedSuite);
    // if (this.bottomSelectedList.length != 0) {
    //   this.addAllFromSuite(false);
    //   document.getElementById("selectAllRemove").checked = false;
  }
  addToEntityTypeFilterSuite(id: any, isChecked: any) {
    if (isChecked) {
      this.eutTypeSelectedSuite.push(id);
    } else {
      var isPresent = this.eutTypeSelectedSuite.findIndex((eut: any) => eut == id);
      if (isPresent > -1) {
        this.eutTypeSelectedSuite.splice(isPresent, 1);
      }
    }
  }
  // }

  isPresentInCollectionSuite(eutID: any) {
    var isPresent = this.eutSelectedSuite.findIndex((eut: any) => eut == eutID);
    if (isPresent > -1) {
      return true;
    } else return false;
  }

  addToPersonaFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.moduleSelected.push(id);
    } else {
      var isPresent = this.moduleSelected.findIndex(
        (persona: any) => persona == id
      );
      if (isPresent > -1) {
        this.moduleSelected.splice(isPresent, 1);
      }
    }
    this.countScenarioEUTType(this.allScenarios);
    if (this.topSelectedList.length != 0) {
      this.addAllFromScenarios(false);
      // document.getElementById("selectAllAdd").checked = false;
    }
  }
  isPresentInPCollection(persona: any) {
    var isPresent = this.moduleSelected.some((r: any) => persona.includes(r));
    if (isPresent) {
      return true;
    } else return false;
  }

  addToModuleFilterSuite(id: any, isChecked: any) {
    if (isChecked) {
      this.moduleSelectedSuite.push(id);
    } else {
      var isPresent = this.moduleSelectedSuite.findIndex(
        (persona: any) => persona == id
      );
      if (isPresent > -1) {
        this.moduleSelectedSuite.splice(isPresent, 1);
      }
    }
    this.countSuiteScenarioEUTType(this.selectedSuite);
    if (this.bottomSelectedList.length != 0) {
      this.addAllFromSuite(false);
      // document.getElementById("selectAllRemove").checked = false;
    }
  }
  isPresentInMCollectionSuite(eID: any) {
    var module = this.modelData.listOfEUTs.find(
      (eut: any) => eut.eID == eID
    );
    var isPresent = this.moduleSelectedSuite.some((r: any) =>
      module.mID.includes(r)
    );
    if (isPresent) {
      return true;
    } else return false;
  }

  addToAttributeFilter(id: any, isChecked: any) {
    if (isChecked) {
      this.attributeSelected.push(id);
    } else {
      var isPresent = this.attributeSelected.findIndex((a: any) => a == id);
      if (isPresent > -1) {
        this.attributeSelected.splice(isPresent, 1);
      }
    }
    this.countScenarioEUTType(this.allScenarios);
    if (this.topSelectedList.length != 0) {
      this.addAllFromScenarios(false);
      // document.getElementById("selectAllAdd").checked = false;
    }
  }
  isPresentInACollection(attribute: any) {
    var isPresent = this.attributeSelected.findIndex(
      (a: any) => a == attribute
    );
    if (isPresent > -1) {
      return true;
    } else return false;
  }

  addToAttributeFilterSuite(id: any, isChecked: any) {
    if (isChecked) {
      this.attributeSelectedSuite.push(id);
    } else {
      var isPresent = this.attributeSelectedSuite.findIndex(
        (a: any) => a == id
      );
      if (isPresent > -1) {
        this.attributeSelectedSuite.splice(isPresent, 1);
      }
    }
    this.countSuiteScenarioEUTType(this.selectedSuite);
    if (this.bottomSelectedList.length != 0) {
      this.addAllFromSuite(false);
      // document.getElementById("selectAllRemove").checked = false;
    }
  }
  isPresentInACollectionSuite(attribute: any) {
    var isPresent = this.attributeSelectedSuite.findIndex(
      (a: any) => a == attribute
    );
    if (isPresent > -1) {
      return true;
    } else return false;
  }

  addToPriorityFilter(priority: any, isChecked: any) {
    if (isChecked) {
      this.prioritySelected.push(priority);
    } else {
      var isPresent = this.prioritySelected.findIndex(
        (p: any) => p == priority
      );
      if (isPresent > -1) {
        this.prioritySelected.splice(isPresent, 1);
      }
    }
    this.countScenarioEUTType(this.allScenarios);
    if (this.topSelectedList.length != 0) {
      this.addAllFromScenarios(false);
      // document.getElementById("selectAllAdd").checked = false;
    }
  }
  isPresentInPrCollection(level: any) {
    var isPresent = this.prioritySelected.findIndex((p: any) => p == level);
    if (isPresent > -1) {
      return true;
    } else return false;
  }

  addToPriorityFilterSuite(level: any, isChecked: any) {
    if (isChecked) {
      this.levelSelectedSuite.push(level);
    } else {
      var isPresent = this.levelSelectedSuite.findIndex(
        (p: any) => p == level
      );
      if (isPresent > -1) {
        this.levelSelectedSuite.splice(isPresent, 1);
      }
    }
    this.countSuiteScenarioEUTType(this.selectedSuite);
    if (this.bottomSelectedList.length != 0) {
      this.addAllFromSuite(false);
      // document.getElementById("selectAllRemove").checked = false;
    }
  }
  isPresentInLevelCollectionSuite(level: any) {
    var isPresent = this.levelSelectedSuite.findIndex(
      (p: any) => p == level
    );
    if (isPresent > -1) {
      return true;
    } else return false;
  }

  addToCrFilter(cr: any, isChecked: any) {
    if (isChecked) {
      this.crSelected.push(cr);
    } else {
      var isPresent = this.crSelected.findIndex((value: any) => value == cr);
      if (isPresent > -1) {
        this.crSelected.splice(isPresent, 1);
      }
    }
    this.countScenarioEUTType(this.allScenarios);
    if (this.topSelectedList.length != 0) {
      this.addAllFromScenarios(false);
      // document.getElementById("selectAllAdd").checked = false;
    }
  }
  isPresentInCrCollection(cr: any) {
    var isPresent = this.crSelected.findIndex((value: any) => value == cr);
    if (isPresent > -1) {
      return true;
    } else return false;
  }
  isPresentIneTypeCollection(eID: any) {
    var foundEUT = this.modelData.listOfEUTs.find(
      (eut: any) => eut.eID == eID
    );
    var isPresent = this.eutTypeSelected.findIndex((value: any) => value == foundEUT.eType);
    if (isPresent > -1) {
      return false;
    } else return true;
  }

  addToCrFilterSuite(cr: any, isChecked: any) {
    if (isChecked) {
      this.crSelectedSuite.push(cr);
    } else {
      var isPresent = this.crSelectedSuite.findIndex(
        (value: any) => value == cr
      );
      if (isPresent > -1) {
        this.crSelectedSuite.splice(isPresent, 1);
      }
    }
    this.countSuiteScenarioEUTType(this.selectedSuite);
    if (this.bottomSelectedList.length != 0) {
      this.addAllFromSuite(false);
      // document.getElementById("selectAllRemove").checked = false;
    }
  }
  isPresentInCrCollectionSuite(cr: any) {
    var isPresent = this.crSelectedSuite.findIndex((value: any) => value == cr);
    if (isPresent > -1) {
      return true;
    } else return false;
  }
  isPresentIneTypeSuiteCollection(eID: any) {
    var foundEUT = this.modelData.listOfEUTs.find(
      (eut: any) => eut.eID == eID
    );
    var isPresent = this.eutTypeSelected.findIndex((value: any) => value == foundEUT.eType);
    if (isPresent > -1) {
      return false;
    } else return true;
  }
  addAllFromScenarios(isSelectAllChecked: any) {
    if (isSelectAllChecked) {
      this.modelData.scenarios.forEach((scenario: any) => {
        var scenExist = this.selectedSuite.scenarios.find(
          (scen: any) => scen == scenario.scenID
        );
        if (!scenExist) {
          if (
            (this.isPresentInCollection(scenario.eID) ||
              !(this.eutSelected.length > 0)) &&
            (this.isPresentInPCollection(scenario.persona) ||
              !(this.moduleSelected.length > 0)) &&
            (this.isPresentInACollection(scenario.tID) ||
              !(this.attributeSelected.length > 0)) &&
            (this.isPresentInPrCollection(scenario.priority) ||
              !(this.prioritySelected.length > 0)) &&
            (this.isPresentInCrCollection(scenario.cr) ||
              !(this.crSelected.length > 0)) &&
            (!this.isPresentInSuite(scenario.scenID) ||
              !(this.selectedSuite.scenarios.length > 0)) &&
            (!this.isPresentIneTypeCollection(scenario.eID) ||
              !(this.eutTypeSelected.length > 0))
            // this.getEntity(scenario.eID).eType == this.selectedEUT
          ) {
            var record = this.modelData.listOfEUTs.find(
              (eut: any) => eut.eID == scenario.eID
            );
            if (record) {
              // if (record.eType == this.selectedEUT) {
              this.topSelectedList.push(scenario.scenID);
              // }
            }
          }
        }
      });
    } else {
      this.topSelectedList = [];
    }
  }

  addAllFromSuite(isSelectAllChecked: any) {
    if (isSelectAllChecked) {
      this.selectedSuite.scenarios.forEach((scenario: any) => {
        var scenarioDetails = this.getScenario(scenario.trim());
        // console.log('scenarioDetails', scenarioDetails);
        if (scenarioDetails) {
          // console.log("entered");
          if (
            (this.isPresentInCollectionSuite(scenarioDetails.eID) ||
              !(this.eutSelectedSuite.length > 0)) &&
            (this.isPresentInMCollectionSuite(scenarioDetails.persona) ||
              !(this.moduleSelectedSuite.length > 0)) &&
            (this.isPresentInACollectionSuite(scenarioDetails.tID) ||
              !(this.attributeSelectedSuite.length > 0)) &&
            (this.isPresentInLevelCollectionSuite(scenarioDetails.attribute.level) ||
              !(this.levelSelectedSuite.length > 0)) &&
            (this.isPresentInCrCollectionSuite(scenarioDetails.cr) ||
              !(this.crSelectedSuite.length > 0)) &&
            (this.isPresentInSuite(scenarioDetails.scenID) ||
              !(this.selectedSuite.scenarios.length > 0)) &&
            (!this.isPresentIneTypeSuiteCollection(scenario.eID) ||
              !(this.eutTypeSelectedSuite.length > 0))
            // this.getEntity(scenarioDetails.eID).eType == this.selectedEUTSuite
          ) {
            //  &&
            //   (this.isPresentInMCollectionSuite(scenarioDetails.persona) || !(this.moduleSelectedSuite.length > 0)) &&
            //   (this.isPresentInACollectionSuite(scenarioDetails.tID) || !(this.attributeSelectedSuite.length > 0)) &&
            //   (this.isPresentInLevelCollectionSuite(scenarioDetails.priority) || !(this.levelSelectedSuite.length > 0)) &&
            //   (this.isPresentInCrCollectionSuite(scenarioDetails.cr) || !(this.crSelectedSuite.length > 0)) &&
            //   (this.isPresentInSuite(scenarioDetails.scenID) || !(this.selectedSuite.scenarios.length > 0))) &&
            //   (this.getEntity(scenarioDetails.eID).eType == this.selectedEUTSuite)) {
            // console.log("1");
            if (scenarioDetails.EorT == 'E') {
              // console.log("2");
              var record = this.modelData.listOfEUTs.find(
                (eut: any) => eut.eID == scenarioDetails.eID
              );
              // console.log("3",record);
              if (record) {
                // console.log("4",this.selectedEUT);
                // if (record.eType == this.selectedEUT) {
                // console.log("5",scenario);
                this.bottomSelectedList.push(scenario);
              }
            }
          }
          // }
        }
      });
      // console.log(this.bottomSelectedList);
    } else {
      this.bottomSelectedList = [];
    }
  }

  clear() {
    this.showText = false;
    if (this.updateSuitename == true) {
      this.selectedSuite.suiteName = this.oldSuiteName;
      // this.chooseSuite(false, false, this.selectedSuite);
      this.updateSuitename = false;
    } else if (this.updateSuitename == false) {
      this.selectedSuite = { suiteId: '', suiteName: '', scenarios: [] };
    }
  }

  getPersona(persona: any) {
    var concat = '';
    for (var i = 0; i < persona.length; i++) {
      var person = this.modelData.persona.find(
        (p: any) => p.pType == persona[i]
      );
      if (person) {
        if (concat == '') {
          concat += person.pName;
        } else {
          concat += ',' + person.pName;
        }
      }
    }
    var person = this.modelData.persona.find((p: any) => p.pType == persona);
    return person;
  }
  switchTab(type: any) {
    if (type == 'scenarios') {
      this.activeTab = 'scenarios';
    } else {
      this.activeTab = 'suites';
    }
  }
  generateReport(auto: any) {
    if (this.activeTab == 'scenarios') {
      let suitesArray = ['Manager'];
      window.localStorage.setItem('exportedData', JSON.stringify(suitesArray));
      if (auto == 'true') {
        window.open('/exportReport', '_blank');
        window.localStorage.setItem('autoDownload', 'true');
      }
      // window.open('/exportReport', '_blank');
    }
    if (this.activeTab == 'suites') {
      // console.log('this.selectedSuite.suiteName', this.selectedSuite.suiteName);
      if (this.selectedSuite.suiteName != '') {
        let suitesArray = ['Suites'];
        window.localStorage.setItem(
          'exportedData',
          JSON.stringify(suitesArray)
        );
        if (auto == 'true') {
          window.open('/exportReport', '_blank');
          window.localStorage.setItem('autoDownload', 'true');
        }
        window.localStorage.setItem(
          'selectedSuite',
          this.selectedSuite.suiteName
        );
        // window.open('/exportReport', '_blank');
      }
    }
  }
  countScenarioEUTType(scenarios: any) {
    this.matchedScenarioCount = 0;
    for (let e = 0; e < scenarios.length; e++) {
      if (
        (this.isPresentInCollection(scenarios[e].eID) ||
          !(this.eutSelected.length > 0)) &&
        (this.isPresentInPCollection(scenarios[e].eID) ||
          !(this.moduleSelected.length > 0)) &&
        (this.isPresentInACollection(scenarios[e].tID) ||
          !(this.attributeSelected.length > 0)) &&
        (this.isPresentInPrCollection(scenarios[e].priority) ||
          !(this.prioritySelected.length > 0)) &&
        (this.isPresentInCrCollection(scenarios[e].cr) ||
          !(this.crSelected.length > 0)) &&
        (!this.isPresentInSuite(scenarios[e].scenID) ||
          !(this.selectedSuite.scenarios.length > 0)) &&
        this.getEntity(scenarios[e].eID).eType == this.selectedEUT
      ) {
        // var record = this.modelData.listOfEUTs.find(eut => eut.eID == scenarios[e].eID);
        // if (record) {
        //   if (record.eType == this.selectedEUT) {
        this.matchedScenarioCount++;
        //   }
        // }
      }
    }
    if (this.matchedSuiteScenarioCount == undefined) {
      this.matchedSuiteScenarioCount = 0;
    }
  }

  //function to get modulename by entityID
  getModuleNameByeID(eID: any) {
    var foundEUT: any = this.modelData.listOfEUTs.find(
      (mod: any) => mod.eID == eID
    );
    var foundModule: any = this.modelData.modules.find(
      (mod: any) => mod.mID == foundEUT.mID
    );
    return foundModule.mName;
  }

  //function to get modulename by moduleID
  getModuleName(eut: any) {
    var foundModule: any = this.modelData.modules.find(
      (mod: any) => mod.mID == eut.mID
    );
    return foundModule.mName;
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, (iframe) => {
      iframe.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'stopVideo',
        }),
        '*'
      );
    });
  }
  countSuiteScenarioEUTType(suiteScenarios: any) {
    this.matchedSuiteScenarioCount = 0;
    if (suiteScenarios.scenarios != undefined) {
      for (let f = 0; f < suiteScenarios.scenarios.length; f++) {
        var scenario = this.getScenario(suiteScenarios.scenarios[f]);
        if (
          (this.isPresentInCollectionSuite(scenario.eID) ||
            !(this.eutSelectedSuite.length > 0)) &&
          (this.isPresentInMCollectionSuite(scenario.eID) ||
            !(this.moduleSelectedSuite.length > 0)) &&
          (this.isPresentInACollectionSuite(scenario.tID) ||
            !(this.attributeSelectedSuite.length > 0)) &&
          (this.isPresentInLevelCollectionSuite(scenario.attribute.level) ||
            !(this.levelSelectedSuite.length > 0)) &&
          (this.isPresentInCrCollectionSuite(scenario.cr) ||
            !(this.crSelectedSuite.length > 0)) &&
          (this.isPresentInSuite(scenario.scenID) ||
            !(this.selectedSuite.scenarios.length > 0)) &&
          this.getEntity(scenario.eID).eType == this.selectedEUTSuite
        ) {
          // console.log('scenario', scenario);
          this.matchedSuiteScenarioCount++;
        }
        // if (scenario) {
        //   if (scenario.EorT == "E") {
        //     var record = this.modelData.listOfEUTs.find(eut => eut.eID == scenario.eID);
        //     if (record) {
        //       if (record.eType == this.selectedEUT) {
        //       }
        //     }
        //   }
        // }
      }
    }
  }
}
